import { Membership } from "./membership";
import { MembershipHandicap } from "./membershipHandicap";

export class AccountMembership {
    accountMembershipId: number;

    membership: Membership;
    membershipId: number;
    rodeoId: number;

    id: string;
    activated: string;
    expiration: string;
    permit: boolean;

    wasSet: boolean;
    show: boolean;

    handicaps: MembershipHandicap[];
    isExpired: boolean;

    constructor() {
        this.handicaps = [];
    }
}


// WEBPACK FOOTER //
// ./src/model/accountMembership.ts